import type { FillBound, FillBounds } from '../fillInput';

export const numberOf = (bound: FillBound | undefined): number | undefined =>
  typeof bound?.value === 'number' ? bound.value : undefined;

export const keptRows = (required: boolean, bounds: FillBounds): number =>
  required ? Math.max(numberOf(bounds.min) ?? 0, 1) : 0;
